import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {FormattedMessage} from 'react-intl';
import {Form, Dropdown, Label} from 'semantic-ui-react';
import {setQueryAction} from '../actions';
import {countriesBySiteId} from '../utils';

const mapStateToProps = state => {
  const {currentQuery} = state.userManagement;
  return {
    currentQuery,
    currentSite: currentQuery.siteId,
    options: Object.keys(state.sites.resources).reduce((options, siteId) => {
      const site = state.sites.resources[siteId];

      options.push({
        active: false,
        selected: false,
        key: site.domain + site.id,
        value: site.id,
        text: countriesBySiteId[site.id]
      });

      return options;
    }, [])
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  setQuery: setQueryAction
}, dispatch);

// for clearing this dropdown and its corresponding field in the current query.
const wildcardOption = {
  active: false,
  selected: false,
  key: 'any',
  value: '',
  text: '[any]'
};

const SiteIdDropdown = compose(
  setDisplayName('SiteIdDropdown'),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    const activeOption = props.options.find(option => option.value === props.currentSite);
    const text = activeOption
      ? activeOption.text
      : <FormattedMessage id='userManagement.searchPanel.siteId.text' />;

    return {
      text,
      setSite: (event, {value}) => props.setQuery({...props.currentQuery, siteId: value})
    };
  })
)(props => (
  <Form.Field>
    <p><FormattedMessage id='userManagement.searchPanel.siteId' /></p>
    <Dropdown
      text={props.text}
      options={[wildcardOption].concat(props.options)}
      value={props.currentSite}
      onChange={props.setSite}
      fluid
      selection
      closeOnBlur
      closeOnChange
      openOnFocus={false}
      selectOnBlur={false}
      selectOnNavigation={false} />
  </Form.Field>
));

export default SiteIdDropdown;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserSearchPanel/SiteIdDropdown.jsx